import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class stdClassLabelService {
  // 新增标签
  static async addClassLabel(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassLabel', payload))
    return Callback(err, res)
  }
  // 获取标签列表
  static async getClassLabelList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassLabel?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 编辑标签
  static async updateClassLabel(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/StdClassLabel/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 获取标签详情
  static async getClassLabel(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClassLabel/${payload}`))
    return Callback(err, res)
  }
  // 删除标签
  static async removeClassLabel(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance('/api/std/StdClassLabel/many', {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导出
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassLabel/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
}
